import React from 'react';
import styled from 'styled-components';
import TopBar from './TopBar';
import Footer from './Footer';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

interface PageLayoutProps {
  children: React.ReactNode;
  isMeasuring?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, isMeasuring = false }) => {
  return (
    <Wrapper>
      <TopBar isMeasuring={isMeasuring} />
      <Content>{children}</Content>
      <Footer />
    </Wrapper>
  );
};

export default PageLayout;
